import React, { useState, useEffect } from 'react';
import classnames from 'classnames'
import CreateTicket from './CreateTicket';

declare var meeApiSettings: any

interface Ticket {
  id: number
  name: string
  body: string
  date: string
}

const App = () => {

  const [tickets, setTickets] = useState<Ticket[]>([])
  const [activeTicket, setActiveTicket] = useState<Ticket | null>(null)
  
  useEffect(() => {
    fetch(meeApiSettings.root + '/users/me/tickets', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        // 'X-WP-Nonce': meeApiSettings.nonce,
      },
      // credentials: 'include',
    })
      .then(res => res.json())
      .then((tickets: Ticket[]) => {
        setTickets(tickets)
      })
  }, []);

  const handleClick = (ticket: Ticket) => {
    setActiveTicket(ticket)
  }
  
  return (
    <div className="App">
      <CreateTicket></CreateTicket>
      { false ? 
      <div className="my-5">
        <div className="container">
          <ul className="list-group list-group-flush">
            { tickets.map(ticket => {
              return (
                <li className={classnames(["list-group-item", {'bg-light': activeTicket === ticket}])} key={'ticket-' + ticket.id} onClick={() => {
                  handleClick(ticket)
                }}>
                  <div className="row">
                    <div className="col-md">
                      { ticket.name }
                    </div>
                    <div className="col-md-auto">
                      { ticket.date }
                    </div>
                  </div>
                  <div className={classnames(['ticket-body text-muted py-3', { 'd-none': activeTicket !== ticket }])}>
                    { ticket.body }
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
      : undefined}
    </div>
  );
}

export default App;
